import { get } from 'lodash';
import { CONST_GBP_EQUIVALENT, CONST_AMOUNT_UPPERCASE } from '../../../src/constants/Constants';
import accounts from '../props/accounts';

const from_account = {
	account_number: get(accounts[0], 'accountNumber', '50017756'),
	account_name: 'fromAcc',
	sort_code: get(accounts[0], 'sortCode', '826817'),
};

export const chapsBatchVerificationAll = [
	{
		verification_id: '0288a382-f0ca-11e9-b8ea-e54efe34f5df',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:38:24.751+0100',
		total: 3756,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '05dd9ae0-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 879,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60739657',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '0288a382-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001319',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '05dd9ae1-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 999,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22354494',
					name: 'Hard Token au',
					sort_code: '050646',
				},
				reference: 'Hard Token AU',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '0288a382-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001320',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '05dd9ae0-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 879,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60739657',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '0288a382-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001319',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '05dd9ae1-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 999,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22354494',
					name: 'Hard Token au',
					sort_code: '050646',
				},
				reference: 'Hard Token AU',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '0288a382-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001320',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '106b4190-f0cc-11e9-b9c5-4939b558c4e1',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:51:51.528+0100',
		total: 522,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '106b4190-f0cc-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 522,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'CHAPS REFERENCE',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001341',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '17361b42-f0cb-11e9-b8ea-e54efe34f5df',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:44:51.716+0100',
		total: 3330,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '1ba1d9d0-f0cb-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 777,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60739657',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '17361b42-f0cb-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001332',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '1ba1d9d1-f0cb-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 888,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22354494',
					name: 'Hard Token au',
					sort_code: '050646',
				},
				reference: 'Hard Token AU',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '17361b42-f0cb-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001333',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '1ba1d9d0-f0cb-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 777,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60739657',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '17361b42-f0cb-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001332',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '1ba1d9d1-f0cb-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 888,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22354494',
					name: 'Hard Token au',
					sort_code: '050646',
				},
				reference: 'Hard Token AU',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '17361b42-f0cb-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001333',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '31ebe171-e8f3-11e9-a08a-5b9b47e0351b',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-07T12:12:06.934+0100',
		total: 502,
		verification_type: 'SOFT',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '31ebe171-e8f3-11e9-a08a-5b9b47e0351b',
				type: 'CBFT',
				amount: 502,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '17005087',
					name: 'ChapsBenf1',
					sort_code: '050469',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-07',
				value_date: '2019-10-07',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: '1570446724860y28',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '31ebe172-e8f3-11e9-a08a-5b9b47e0351b',
		status: 'PENDING',
		created_timestamp: '2019-10-07T12:12:12.235+0100',
		total: 503,
		verification_type: 'SOFT',
		final_approval: true,
		chaps: [
			{
				payment_uuid: '31ebe172-e8f3-11e9-a08a-5b9b47e0351b',
				type: 'CBFT',
				amount: 503,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'CBCustNick',
					sort_code: '050646',
				},
				reference: 'CBCustRef',
				submission_date: '2019-10-07',
				value_date: '2019-10-07',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'PENDING',
					},
				],
				payment_instruction_id: '1570446729292TSG',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '357dc3e0-f0cc-11e9-b9c5-4939b558c4e1',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:52:39.381+0100',
		verification_type: 'HARD',
		payments: [
			{
				payment_uuid: '357dc3e0-f0cc-11e9-b9c5-4939b558c4e1',
				type: 'BFT',
				amount: 511,
				currency: 'GBP',
				source_account: '05064622358633',
				from_account,
				target_account: '05064622354494',
				to_account: {
					account_number: '22354494',
					name: 'Hard Token au',
					sort_code: '050646',
				},
				reference: 'Hard Token AU',
				start_date: '2019-10-17',
				beneficiary_name: 'Hard Token au',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
			},
		],
		final_approval: false,
	},
	{
		verification_id: '456c7150-e467-11e9-80e5-dd658bc07dff',
		status: 'PENDING',
		created_timestamp: '2019-10-01T17:19:58.362+0100',
		total: 767,
		verification_type: 'SOFT',
		final_approval: true,
		chaps: [
			{
				payment_uuid: '456c7150-e467-11e9-80e5-dd658bc07dff',
				type: 'CBFT',
				amount: 767,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '17005087',
					name: 'ChapsBenf1',
					sort_code: '050469',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-01',
				value_date: '2019-10-01',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'PENDING',
					},
				],
				payment_instruction_id: '1569946797126wUQ',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '5336a350-f3e9-11e9-8338-1b848e5351a1',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-21T10:58:39.187+0100',
		total: 789,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '5336a350-f3e9-11e9-8338-1b848e5351a1',
				type: 'CBFT',
				amount: 789,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'CBCustNick',
					sort_code: '050646',
				},
				reference: 'CBCustRef',
				submission_date: '2019-10-21',
				value_date: '2019-10-21',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001600',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '59dc3c30-e50a-11e9-b5fb-a78574bfa700',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-02T12:47:23.166+0100',
		total: 999,
		verification_type: 'SOFT',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '59dc3c30-e50a-11e9-b5fb-a78574bfa700',
				type: 'CBFT',
				amount: 999,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '17005087',
					name: 'ChapsBenf1',
					sort_code: '050469',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-02',
				value_date: '2019-10-02',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: '1570016842029vj3',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '5f387f40-f0d1-11e9-b9c5-4939b558c4e1',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T12:29:37.053+0100',
		total: 511,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '5f387f40-f0d1-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 511,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'CHAPS REFERENCE',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001352',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '60eb6392-f0ca-11e9-b8ea-e54efe34f5df',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:39:47.175+0100',
		total: 3390,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '64183980-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 897,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60739657',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '60eb6392-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001327',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '64186090-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 798,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22354494',
					name: 'Hard Token au',
					sort_code: '050646',
				},
				reference: 'Hard Token AU',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '60eb6392-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001328',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '64183980-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 897,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60739657',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '60eb6392-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001327',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: '64186090-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 798,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22354494',
					name: 'Hard Token au',
					sort_code: '050646',
				},
				reference: 'Hard Token AU',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: '60eb6392-f0ca-11e9-b8ea-e54efe34f5df',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001328',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '6d88bca0-f96d-11e9-b7c9-8bf80cb6145a',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-28T10:27:46.480+0000',
		total: 789,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '6d88bca0-f96d-11e9-b7c9-8bf80cb6145a',
				type: 'CBFT',
				amount: 789,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '68025071',
					name: 'Hard Token au',
					sort_code: '050303',
				},
				reference: 'Hard Token AU',
				submission_date: '2019-10-28',
				value_date: '2019-10-28',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000003288',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '7172a100-f96d-11e9-b7c9-8bf80cb6145a',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-28T10:27:47.948+0000',
		total: 765,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '7172a100-f96d-11e9-b7c9-8bf80cb6145a',
				type: 'CBFT',
				amount: 765,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-28',
				value_date: '2019-10-28',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000003289',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: '9274d4b0-e444-11e9-904b-7d312d9ca802',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-01T13:11:28.407+0100',
		total: 544,
		verification_type: 'SOFT',
		final_approval: false,
		chaps: [
			{
				payment_uuid: '9274d4b0-e444-11e9-904b-7d312d9ca802',
				type: 'CBFT',
				amount: 544,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '17005087',
					name: 'ChapsBenf1',
					sort_code: '050469',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-01',
				value_date: '2019-10-01',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: '1569931887668Hes',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: 'adf5f642-f96d-11e9-b7c9-8bf80cb6145a',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-28T10:29:06.528+0000',
		total: 1889,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: 'b34fe561-f96d-11e9-b7c9-8bf80cb6145a',
				type: 'CBFT',
				amount: 999,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'ChapsBenf1',
					sort_code: '050646',
				},
				reference: 'chaps',
				submission_date: '2019-10-28',
				value_date: '2019-10-28',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'adf5f642-f96d-11e9-b7c9-8bf80cb6145a',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000003293',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'b34fe560-f96d-11e9-b7c9-8bf80cb6145a',
				type: 'CBFT',
				amount: 890,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'CHAPS REFERENCE',
				submission_date: '2019-10-28',
				value_date: '2019-10-28',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'adf5f642-f96d-11e9-b7c9-8bf80cb6145a',
				batch_name: 'Batch Payment',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000003292',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: 'c19c4840-e467-11e9-80e5-dd658bc07dff',
		status: 'PENDING',
		created_timestamp: '2019-10-01T17:39:33.344+0100',
		total: 4555,
		verification_type: 'SOFT',
		final_approval: true,
		chaps: [
			{
				payment_uuid: 'c19c4840-e467-11e9-80e5-dd658bc07dff',
				type: 'CBFT',
				amount: 4555,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '17005087',
					name: 'ChapsBenf1',
					sort_code: '050469',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-01',
				value_date: '2019-10-01',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'PENDING',
					},
				],
				payment_instruction_id: '1569947010727Omu',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: 'c1d88b80-e4f7-11e9-96f5-bfb6ec43cec0',
		status: 'PENDING',
		created_timestamp: '2019-10-02T10:40:03.226+0100',
		total: 501,
		verification_type: 'SOFT',
		final_approval: true,
		chaps: [
			{
				payment_uuid: 'c1d88b80-e4f7-11e9-96f5-bfb6ec43cec0',
				type: 'CBFT',
				amount: 501,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '17005087',
					name: 'ChapsBenf1',
					sort_code: '050469',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-02',
				value_date: '2019-10-02',
				creator_id: '9000205370',
				creator_name: 'Corporatea Admintwo',
				approvers: [
					{
						id: '9000203624',
						status: 'PENDING',
					},
				],
				payment_instruction_id: '1570009200222wNZ',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:50:21.834+0100',
		total: 1935,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: 'd086bff0-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 444,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'CHAPS REFERENCE',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001338',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086e700-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 51,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'ChapsBenf1',
					sort_code: '050646',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001339',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086e701-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 150,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '70103529',
					name: 'CBCustNick',
					sort_code: '826817',
				},
				reference: 'CBCustRef',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001340',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086bff0-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 444,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'CHAPS REFERENCE',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001338',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086e700-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 51,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'ChapsBenf1',
					sort_code: '050646',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001339',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086e701-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 150,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '70103529',
					name: 'CBCustNick',
					sort_code: '826817',
				},
				reference: 'CBCustRef',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001340',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086bff0-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 444,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'CHAPS REFERENCE',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001338',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086e700-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 51,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '60740998',
					name: 'ChapsBenf1',
					sort_code: '050646',
				},
				reference: 'th1 PAYMENTs',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001339',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
			{
				payment_uuid: 'd086e701-f0cb-11e9-b9c5-4939b558c4e1',
				type: 'CBFT',
				amount: 150,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '70103529',
					name: 'CBCustNick',
					sort_code: '826817',
				},
				reference: 'CBCustRef',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				batch_id: 'caa63bb2-f0cb-11e9-b9c5-4939b558c4e1',
				batch_name: 'Batch Payment Viju',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001340',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: 'cacdf430-f96c-11e9-b7c9-8bf80cb6145a',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-28T10:22:19.502+0000',
		verification_type: 'HARD',
		payments: [
			{
				payment_uuid: 'cacdf430-f96c-11e9-b7c9-8bf80cb6145a',
				type: 'BFT',
				amount: 988,
				currency: 'GBP',
				source_account: '05064622358633',
				from_account,
				target_account: '05064660740998',
				to_account: {
					account_number: '60740998',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'REFERENCE OTHER12',
				start_date: '2019-10-28',
				beneficiary_name: 'CHAPS-BEN-DG',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
			},
		],
		final_approval: false,
	},
	{
		verification_id: 'd62d71a0-ef2d-11e9-900e-bd9a57cd0e27',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-15T10:26:28.389+0100',
		total: 678,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: 'd62d71a0-ef2d-11e9-900e-bd9a57cd0e27',
				type: 'CBFT',
				amount: 678,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'CBCustNick',
					sort_code: '050646',
				},
				reference: 'CBCustRef',
				submission_date: '2019-10-15',
				value_date: '2019-10-15',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000000850',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 5,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: 'dae479d0-f0c9-11e9-b8ea-e54efe34f5df',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:36:27.692+0100',
		total: 897,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: 'dae479d0-f0c9-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 897,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'HARD TOKEN DG',
					sort_code: '050646',
				},
				reference: 'HARD TOKEN DG',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001316',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
	{
		verification_id: 'e9353870-f0ca-11e9-b8ea-e54efe34f5df',
		status: 'CHALLENGE',
		created_timestamp: '2019-10-17T11:44:21.285+0100',
		total: 897,
		verification_type: 'HARD',
		final_approval: false,
		chaps: [
			{
				payment_uuid: 'e9353870-f0ca-11e9-b8ea-e54efe34f5df',
				type: 'CBFT',
				amount: 897,
				currency: 'GBP',
				from_account,
				to_account: {
					account_number: '22358633',
					name: 'CHAPS-BEN-DG',
					sort_code: '050646',
				},
				reference: 'CHAPS REFERENCE',
				submission_date: '2019-10-17',
				value_date: '2019-10-17',
				creator_id: '9000203624',
				creator_name: 'Corporatea Adminone',
				approvers: [
					{
						id: '9000203624',
						status: 'CHALLENGE',
					},
				],
				payment_instruction_id: 'WCI000000001329',
				charge_amount: [
					{
						type: 'AMOUNT',
						value: 20.05,
						currency: 'GBP',
					},
				],
			},
		],
	},
];

export const approveCHAPSOthers = [
	{
		ordinal: '', // TBC - defines the place of this item between all payments of different types (Single/Batch/BACS/IFT/CHAPS)
		id: '20037855-f07c-4298-80c6-9f5a9a5eabcd',
		last_updated_on: '2017-01-02T12:24:00.000Z',
		reference: 'CHAPS PAYMENT REFERENCE',
		status: 'Pending Approval',
		result_code: '1234',
		created_by: 'John Smith',
		created_timestamp: '2019-05-05T00:00:00.000Z',
		settlement_date: '2017-05-30',
		submission_date: '2017-05-27',
		approvers: [
			{
				approver: 'Joe Bloggs',
				status: 'PENDING',
			},
			{
				approver: 'Christopher Sutton',
				status: 'VERIFIED',
			},
		],
		amount: {
			currency: 'GBP',
			value: 88.32,
		},
		from_account: {
			account_number: '50017756',
			name: 'SIMON DAY',
			sort_code: '826817',
		},
		to_account: {
			account_number: '10776013',
			name: 'targetAccName',
			sort_code: '825404',
		},
		charge_amount: [
			{
				type: CONST_AMOUNT_UPPERCASE,
				value: '100.20',
				currency: 'EUR',
			},
			{
				type: CONST_GBP_EQUIVALENT,
				value: '100.20',
				currency: 'GBP',
			},
		],
	},
];
